"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExplodedPicker = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var Option_1 = require("fp-ts/Option");
var function_1 = require("fp-ts/function");
var FlexView_1 = require("../FlexView");
var Icon_1 = require("../Icon");
require("./explodedPicker.css");
var ExplodedPicker = function (_a) {
    var label = _a.label, options = _a.options, onClick = _a.onClick;
    var handleClick = function (slug) { return function () { return onClick(slug); }; };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "exploded-picker" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "exploded-picker-title" }, { children: label.toUpperCase() })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "exploded-picker-content" }, { children: options.map(function (option) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)('exploded-picker-item', option.selected ? 'exploded-picker-item-selected' : '', option.editable ? 'editable' : 'not-editable'), onClick: option.editable ? handleClick(option.slug) : undefined }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { size: "lg", className: "exploded-picker-item-icon", icon: option.optionIcon }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "exploded-picker-item-label" }, { children: option.label })), (0, function_1.pipe)(O.fromNullable(option.optionRightImage), (0, Option_1.map)(function (i) { return ((0, jsx_runtime_1.jsx)(FlexView_1.FlexView, __assign({ hAlignContent: "right", style: { height: '100%', minHeight: '1rem' } }, { children: (0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 2 }, { children: (0, jsx_runtime_1.jsx)("div", { className: i }) })) }))); }), O.toNullable), option.selected ? ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { className: "exploded-picker-item-icon-checkmark", icon: "icon_check_dark" })) : null] }), option.slug)); }) }))] })));
};
exports.ExplodedPicker = ExplodedPicker;
//# sourceMappingURL=ExplodedPicker.js.map